import { Pagination } from '@react-bootstrap/pagination'
import React, { Component } from 'react'

class PaginationField extends Component {
  static defaultProps = {
    lastPage: 1,
    maxButtons: 7,
    input: {},
    submit: () => null,
  }

  onChange = (value) => {
    this.props.input.onChange(value)

    // TODO: patch to trigger submit after onChange
    setTimeout(this.props.submit, 0)
  }

  render() {
    const { lastPage, maxButtons } = this.props

    if (lastPage === 1 && this.props.input.value === 1) return null

    return (
      <div className="paginator">
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          items={lastPage}
          maxButtons={maxButtons}
          activePage={this.props.input.value}
          onSelect={this.onChange}
        />
      </div>
    )
  }
}

export default PaginationField
